import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';
import Select from 'react-select';
import { DataContext } from '../../stores/employee-course-table-store';
import { InputDebouncer, HandleExlFilter } from '../tables/shared/FilterEventHelpers';
import { DataContext as CovDataStore } from '../../store';
import { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import { courseStatusOptions, getOptionsObjectValuesWithLabel, courseRoleOptions } from './shared/translations';
import { useTranslation } from 'react-i18next';
import { SHOW_ALL } from '../../i18n/keyConstants';
//registerLocale('sv', sv);

const FilterCell = ({ column, children, id, ...restProps }) => {
    const { store: covStore } = useContext(CovDataStore);
    const columnName = column.name;
    const { t } = useTranslation(['generalCourseInformation', 'shared']);

    const {
        store: {
            selectedFilters,
            filters,
            isResettingFilters,
            selectedCourseStatus,
            selectedCourseRole,
        },
        dispatch
    } = useContext(DataContext);
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);
    const intervalRef = useRef(null);

    const IsTextInputColumn = () => {
        return (columnName !== 'status');
    }

    const handleOptionValueChange = (selected) => {
        if (column.name === 'status') {
            { dispatch({ type: 'SELECTED_COURSE_STATUS', payload: selected }) }
        }
        else if (column.name === 'role') {
            { dispatch({ type: 'SELECTED_COURSE_ROLE', payload: selected }) }
        }
    }

    useEffect(() => {
        if (IsTextInputColumn()) {
            if (!(chosenValue === selectedFilters[columnName])) {
                return InputDebouncer(column, filters, chosenValue, intervalRef, children, dispatch);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chosenValue]);

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            dispatch({ type: 'SELECTED_FILTERS_AND_FILTERS_RESET', columnName, payload: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    if (columnName === 'status') {
        if (selectedCourseStatus[0]?.label === 'showAll') {
            selectedCourseStatus[0].label = t(SHOW_ALL, { ns: 'shared' })
        }
        return (
            <th>
                <Select className={`${columnName}-select`}
                    isClearable={false}
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={selectedCourseStatus}
                    options={[{ label: t(SHOW_ALL, { ns: 'shared' }), value: '' }, ...getOptionsObjectValuesWithLabel(courseStatusOptions, t)]}
                    onChange={(e) => {
                        HandleExlFilter(e, filters, handleOptionValueChange, columnName, 'equal', '', dispatch);
                    }}
                />
            </th>
        );
    }
    if (columnName === 'role') {
        if (selectedCourseRole[0]?.label === 'showAll') {
            selectedCourseRole[0].label = t(SHOW_ALL, { ns: 'shared' })
        }
        return (
            <th>
                <Select className="status-select"
                    isClearable={false}
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={selectedCourseRole}
                    options={[{ label: t(SHOW_ALL, { ns: 'shared' }), value: '' }, ...getOptionsObjectValuesWithLabel(courseRoleOptions, t)]}
                    onChange={(e) => {
                        HandleExlFilter(e, filters, handleOptionValueChange, columnName, e.value === 0 ? 'isTeacher' : e.value === 1 ? 'isParticipant' : '' , id, dispatch);
                    }}
                />
            </th>
        );
    }

    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        }
    });

    return (
        <TableFilterRow.Cell
            column={column}
            {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
}

export default FilterCell;
